import {initNewTagList} from "../swiper/swiper";

const classPrefix = 'main-banner-demo'
const dataPrefix = 'data-main-banner-demo'
const $container = document.querySelector(`[${dataPrefix}]`)

if ($container) {
    //summaryResults({$container})
    mainBannerDemo()
}

export function mainBannerDemo() {

    const $bannerContainer = $container.querySelector(`[${dataPrefix}-container]`)
    const $bannerContainerCover = $container.querySelector(`[${dataPrefix}-container-cover]`)


    if ($bannerContainer) {
        initNewTagList(`${classPrefix}__container-swiper`)
    }


    if ($bannerContainerCover) {
        const $bannerInfoContainerOpen = $bannerContainer.querySelector(`[${dataPrefix}-info-open]`)
        const $bannerInfoContainerClose = $bannerContainer.querySelector(`[${dataPrefix}-info-close]`)

        $bannerInfoContainerClose.addEventListener('click', () => {
            $bannerContainerCover.classList.remove(`${classPrefix}__container-cover--open`)
        })
        $bannerInfoContainerOpen.addEventListener('click', () => {
            $bannerContainerCover.classList.add(`${classPrefix}__container-cover--open`)
        })
    }

}




